// @flow
import React, { Component } from 'react';
import I18n from '../../../../../../lib/i18n';
import Details from '../Details';

export default class PromotionCodeDetails extends Component<Props> {
  render() {
    const code = this.props.code && this.props.code.toUpperCase();
    const customSubtitle = this.props.customSubtitle;
    const isInvalid = !!this.props.isInvalid;
    const translationKey = `promotion.${code}`;
    const title = I18n.has(`${translationKey}.title`) ? I18n.t(`${translationKey}.title`) : code;
    const subtitle = I18n.has(`${translationKey}.detail`) ? I18n.t(`${translationKey}.detail`) : '';
    return (
      <Details
        icon="invitefriend"
        title={title}
        subtitle={isInvalid ? customSubtitle : subtitle}
        isInvalid={isInvalid}
        onDelete={this.props.onDelete}
      />
    );
  }
}

type Props = {
  code: string,
  customSubtitle: string,
  isInvalid: boolean,
  onDelete: Function,
};
